<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3">
          <card>
            <template slot="header">
              <h4 class="card-title">Password</h4>
            </template>
            <p v-if="loading" class="card-category">
              <center>Caricamento in corso...</center>
            </p>
            <p v-if="testoPrincipale">
              {{testoPrincipale}}
            </p>
            <form v-if="!loading">
              <div class="row">
                <div class="col-md-12 col-xl-12">
                  <fg-input type="password"
                            label="Vecchia password"
                            placeholder="Vecchia password"
                            v-model="vecchia_password"
                            v-show="!readOnly || saving"
                            :disabled="readOnly">
                  </fg-input>
                </div>
                <div class="col-md-12 col-xl-12">
                  <fg-input type="password"
                            label="Nuova password"
                            placeholder="Nuova password"
                            v-model="nuova_password"
                            v-show="!readOnly || saving"
                            :disabled="readOnly">
                  </fg-input>
                </div>
                <div class="col-md-12 col-xl-12">
                  <fg-input type="password"
                            label="Ripeti password"
                            placeholder="Ripeti password"
                            v-model="ripeti_password"
                            v-show="!readOnly || saving"
                            :disabled="readOnly">
                  </fg-input>
                </div>
                <div class="col-md-12 text-right">
                  <button type="submit" :disabled="saving" v-if="saving || !readOnly" class="btn btn-info btn-fill" @click.prevent="salva">
                    Salva
                  </button>
                  <button type="submit" :disabled="saving" v-if="!saving && readOnly" class="btn btn-info btn-fill" @click.prevent="modModifica">
                    Cambia
                  </button>
                </div>
              </div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  
  export default {
    components: {
      Card
    },
    data () {
      return {
        testoPrincipale: 'Premi su cambia per modifica la password di accesso',
        saving: false,
        loading: false,
        readOnly: true,
        vecchia_password: '',
        nuova_password: '',
        ripeti_password: ''
      }
    },
    methods: {
      modModifica: function () {
        this.$data.testoPrincipale = ''
        this.$data.readOnly = false
      },
      salva: function () {
        var me = this
        if (me.$data.nuova_password !== me.$data.ripeti_password) {
          me.ajaxErrorFn('Ripetere correttamente la nuova password')
          return false
        }
        me.$data.readOnly = true
        me.$data.saving = true
        var url = process.env.API_URL + 'auth/user/changepassword'
        var method = 'POST'
        var params = {
          vecchia_password: me.$data.vecchia_password,
          nuova_password: me.$data.nuova_password
        }
        var successFn = function (data) {
          me.$data.vecchia_password = ''
          me.$data.nuova_password = ''
          me.$data.ripeti_password = ''
          me.$data.testoPrincipale = 'La nuova password di accesso è stata salvata'
          me.$data.saving = false
        }
        var errorFn = function (message) {
          me.$data.readOnly = false
          me.$data.saving = false
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/SettingPasswordChange.vue